export default {
  props: {
    resultSet: { type: Array },
    onSelect: { type: Function },
    selected: { type: Number },
  },

  data() {
    return {
      activeResultSet: null,
    };
  },

  methods: {
    setResultSet: setResultSet,
  },

  mounted() {
    this.selected ? (this.activeResultSet = this.selected) : (this.activeResultSet = this._props.resultSet[0]);
  },
};

function setResultSet(value) {
  this.activeResultSet = value;
  this.onSelect(value);
}
